import { useEffect } from 'react';
import useListenToDynamicQuestions from 'chameleon/packages/blue-book-player/hooks/useListenToDynamicQuestions';

const useListenToRenderedQuestions = (playerState, learnosityApp, callback) => {
  const { isTestReady, firstChunkQuestionsApi } = playerState;

  const listenToRenderedQuestions = (questionsApi) => {
    Object.keys(questionsApi).forEach((key) => {
      const questionApi = questionsApi[key];
      if (!questionApi) return;

      // The question might be already rendered when the listener is added
      if (questionApi.isRendered()) {
        const metadata = questionApi.getMetadata();
        callback(metadata.sheet_reference, questionApi);
        return;
      }

      questionApi.once('rendered', () => {
        const metadata = questionApi.getMetadata();
        callback(metadata.sheet_reference, questionApi);
      });
    });
  };

  useListenToDynamicQuestions(learnosityApp, listenToRenderedQuestions);

  useEffect(() => {
    if (isTestReady) {
      listenToRenderedQuestions(firstChunkQuestionsApi);
    }
  }, [isTestReady]);

  useEffect(() => {
    const onLazyLoadBatch = () => {
      listenToRenderedQuestions(learnosityApp?.questions() || {});
    };
    learnosityApp?.on('items:lazyload:batch', onLazyLoadBatch);

    return () => {
      learnosityApp?.off('items:lazyload:batch', onLazyLoadBatch);
    };
  }, [learnosityApp]);

  return [];
};

export default useListenToRenderedQuestions;
